export default "__VITE_ASSET__t86n8b8v__"